import axios from "axios";
import { API } from "./apiClient";

const graphql = async (query, variables = {}) => {
  const response = await axios.post(API, { query, variables }, { withCredentials: true });
  const failure = response.data?.errors?.[0];
  if (failure) {
    const error = new Error(failure.message || "Operator request failed");
    error.code = failure.extensions?.code;
    throw error;
  }
  return response.data?.data;
};

const DESTINATION = `id slug name primary_type publication_state operational_status summary description opening_hours season parking website organization { id name slug verification_status membership_role } access { id status granted_at }`;
const TRAIL = `id destination_id slug name publication_state operational_status difficulty length_km elevation_gain_m elevation_loss_m trail_type riding_style surface description`;
const MEDIA = `id destination_id media_type source_type url provider title publication_status moderation_status created_at`;

export const operatorApi = {
  async workspace() {
    const data = await graphql(`query OperatorWorkspace { operatorWorkspace { organization { id name slug verification_status membership_role } destinations { ${DESTINATION} } } }`);
    return data.operatorWorkspace;
  },

  async destination(destinationId) {
    const data = await graphql(`query OperatorDestination($id: ID!) { operatorDestination(destination_id: $id) { ${DESTINATION} } }`, { id: destinationId });
    return data.operatorDestination;
  },

  async updateDestination(destinationId, changes, reason) {
    const data = await graphql(`mutation UpdateOperatorDestination($input: UpdateOperatorDestinationInput!) { updateOperatorDestination(input: $input) { destination_id slug changed_fields organization_id } }`, {
      input: { destination_id: destinationId, changes, reason },
    });
    return data.updateOperatorDestination;
  },

  async trails(destinationId) {
    const data = await graphql(`query OperatorTrails($id: ID!) { operatorTrails(destination_id: $id) { ${TRAIL} } }`, { id: destinationId });
    return data.operatorTrails;
  },

  async createTrail(input) {
    const data = await graphql(`mutation OperatorCreateTrail($input: OperatorCreateTrailInput!) { operatorCreateTrail(input: $input) { ${TRAIL} } }`, { input });
    return data.operatorCreateTrail;
  },

  async updateTrail(input) {
    const data = await graphql(`mutation OperatorUpdateTrail($input: OperatorUpdateTrailInput!) { operatorUpdateTrail(input: $input) { ${TRAIL} } }`, { input });
    return data.operatorUpdateTrail;
  },

  async media(destinationId) {
    const data = await graphql(`query OperatorMedia($id: ID!) { operatorMedia(destination_id: $id) { ${MEDIA} } }`, { id: destinationId });
    return data.operatorMedia;
  },

  async addVideo(input) {
    const data = await graphql(`mutation OperatorAddVideo($input: OperatorVideoInput!) { operatorAddVideo(input: $input) { ${MEDIA} } }`, { input });
    return data.operatorAddVideo;
  },

  async requestPhotoUpload(input) {
    const data = await graphql(`mutation OperatorRequestPhotoUpload($input: OperatorPhotoUploadInput!) { operatorRequestPhotoUpload(input: $input) { upload_id upload_url method headers { name value } expires_at } }`, { input });
    return data.operatorRequestPhotoUpload;
  },

  async confirmPhotoUpload(uploadId) {
    const data = await graphql(`mutation OperatorConfirmPhotoUpload($id: ID!) { operatorConfirmPhotoUpload(upload_id: $id) { ${MEDIA} } }`, { id: uploadId });
    return data.operatorConfirmPhotoUpload;
  },

  async removeMedia(destinationId, mediaId) {
    const data = await graphql(`mutation OperatorRemoveMedia($destinationId: ID!, $mediaId: ID!) { operatorRemoveMedia(destination_id: $destinationId, media_id: $mediaId) { ${MEDIA} } }`, { destinationId, mediaId });
    return data.operatorRemoveMedia;
  },

  async report(input) {
    const data = await graphql(`mutation OperatorSubmitReport($input: OperatorReportInput!) { operatorSubmitReport(input: $input) { id status submitted_at } }`, { input });
    return data.operatorSubmitReport;
  },
};
